export const INSTITUTES_1_CONSTANTS = {
  // One skill chip. Text capped at 30 chars in the widget.
  DEFAULT_ROW: {
    id: "1",
    meta_title: "",
    meta_priority: "1",
  },

  CARD_FIELDS_CONFIG: [],

  INSTITUTES_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select desktop background color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select mobile background color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "backvariant",
      // Non-empty so a fresh create submits a valid ENUM (empty string truncates the ENUM column).
      label: "Background Variant",
      value: "variant_3",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select background variant",
      required: false,
      defaultValue: "variant_3",
      options: [
        { label: "Variant 1 (Gradient)", value: "variant_1" },
        { label: "Variant 2 (Gradient)", value: "variant_2" },
        { label: "Variant 3 (Solid)", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select gradient color 1",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select gradient color 2",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select gradient color 3",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select gradient color 4",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "font_style",
      // Highlight (heading line 2) font. Denton Test -> Merriweather per the font rule.
      label: "Highlight Font Style",
      value: "var(--font-merriweather)",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select font style",
      required: false,
      defaultValue: "var(--font-merriweather)",
      options: [
        { label: "Merriweather", value: "var(--font-merriweather)" },
        { label: "Google Sans", value: "var(--font-google-sans)" },
        { label: "Circular Std", value: "var(--font-circular-std)" },
      ],
    },
    {
      fieldName: "pre_title",
      label: "Section Heading (line 1)",
      value: "Graduates build careers across",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Graduates build careers across",
      required: false,
      defaultValue: "Graduates build careers across",
    },
    {
      fieldName: "pre_title_color",
      label: "Section Heading Color (line 1)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select section heading color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Section Heading Highlight (line 2)",
      value: "leading financial institutions",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. leading financial institutions",
      required: false,
      defaultValue: "leading financial institutions",
    },
    {
      fieldName: "title_color",
      label: "Section Heading Highlight Color (line 2)",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select highlight color",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "description",
      label: "Section Description",
      value:
        "With the CFP® Global Certification, graduates can pursue international advisory roles, work with global clients, and build cross-border careers in financial planning.",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter section description",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "rgba(255,255,255,0.7)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select description color",
      required: false,
      defaultValue: "rgba(255,255,255,0.7)",
    },
    {
      fieldName: "pill_background_color",
      label: "Pill Background Color",
      value: "rgba(86,226,245,0.2)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select pill background color",
      required: false,
      defaultValue: "rgba(86,226,245,0.2)",
    },
    {
      fieldName: "pill_text_color",
      label: "Pill Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select pill text color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "pill_border_color",
      label: "Pill Border Color",
      value: "rgba(255,255,255,0.2)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select pill border color",
      required: false,
      defaultValue: "rgba(255,255,255,0.2)",
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable animation",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Set status",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Institution / Skill",
      fieldName: "meta_title",
      label: "Institution / Skill (max 30 chars)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Private & Retail Banks",
      required: false,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      label: "Priority",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter priority",
      required: false,
      defaultValue: "1",
    },
  ],
};

export default INSTITUTES_1_CONSTANTS;
